import { Injectable, Injector } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Store, select } from '@ngrx/store';
import { Observable, of, throwError, from } from 'rxjs';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { AppState } from '../+store/app.states';
import { getAuthState } from './+store/auth.selectors';
import { loadUserFailure } from './+store/auth.actions';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  token: string;
  constructor(private store: Store<AppState>) {
    this.store
      .pipe(select(getAuthState))
      .subscribe(state => (this.token = state.token));
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.token) {
      const cloned = req.clone({
        headers: req.headers.set('Authorization', 'Bearer ' + this.token)
      });

      return next.handle(cloned);
    } else {
      return next.handle(req);
    }

    // return this.store.pipe(
    //   select(selectAuthState),
    //   take(1),
    //   map(state => state.token),
    //   mergeMap(token => {
    //     if (token) {
    //       const cloned = req.clone({
    //         headers: req.headers.set("Authorization",
    //           "Bearer " + token)
    //       });

    //       return next.handle(cloned);

    //     } else {
    //       return next.handle(req);
    //     }
    //   })
    // )
  }
  // intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  //   return this.store.select(this.authState.token).pipe(
  //     first(),
  //     flatMap(token => {
  //       const authReq = !!token ? req.clone({
  //         setHeaders: { Authorization: 'Bearer ' + token },
  //       }) : req;
  //       return next.handle(authReq);
  //     }),
  //   );
  // }
}

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private router: Router, private store: Store<AppState>) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          console.error('[ErrorInterceptor] ', '\n:: ', request, '\n:: ', err);
          switch (err.status) {
            case 401:
              this.store.dispatch(loadUserFailure(err));

              break;
          }
        }
        return throwError(() => new Error(err.message));
      })
    );
  }
}
